import * as types from '../types/businessTypes';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const businessReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_BUSINESS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_BUSINESS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case types.FETCH_BUSINESS_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default businessReducer;
